import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from './baseQuery'

/**
 * Initializes and exports an API instance configured with a reducer path, base query, tag types, and endpoints.
 *
 * Documentation: https://redux-toolkit.js.org/rtk-query/overview
 *
 * The API setup includes:
 * - `reducerPath`: Specifies the path in the Redux store where the API state will be stored.
 * - `baseQuery`: Defines the base query function to be used for API requests.
 * - `tagTypes`: Enumerates the types of tags used for cache invalidation and refetching.
 * - `endpoints`: A function that returns an object defining the API endpoints.
 */
export const api = createApi({
    reducerPath: 'api',
    baseQuery: baseQuery(),
    tagTypes: [
        'UserCampaigns',
        'AdminCampaigns',
        'CrontabJobs',
        'CrontabJobHistory',
        'PlatformCountry',
        'PlatformParameter',
        'PlatformParameterValue',
        'MaintenanceScheduled',
        'MaintenancePastSchedules'
    ],
    endpoints: (builder) => ({})
})
